export * from './authentication.service';
import { AuthenticationService } from './authentication.service';
export * from './data.service';
import { DataService } from './data.service';
export * from './demoMode.service';
import { DemoModeService } from './demoMode.service';
export * from './license.service';
import { LicenseService } from './license.service';
export * from './reporting.service';
import { ReportingService } from './reporting.service';
export const APIS = [AuthenticationService, DataService, DemoModeService, LicenseService, ReportingService];
